import React, { Fragment } from 'react';
import { CloseMessageInfoDetailsHoc, EmptyDeliverHoc, OpenMessageInfoDetailsHoc } from '../../../../assets/images';
import Members from './Members';

const SeenMessageWrapper = (props = {}) => {
    const { seenMembers = [], totalMembers = 0, rosterData = {} } = props;
    
    return (
        <Fragment>
            <div className="readByDetailsContainer">
                <input type="checkbox" id="readByDetails" />
                <label htmlFor="readByDetails">
                    <i className="OpenMessageInfoDetails"><OpenMessageInfoDetailsHoc viewBox="0 0 23.807 23.807"/></i>
                    <i className="CloseMessageInfoDetails"><CloseMessageInfoDetailsHoc viewBox="0 0 24.001 24.001"/></i>
                    {`Read by ${seenMembers.length} of ${totalMembers}`}</label>
                {seenMembers.length === 0 && <div className="emptyDelivered">
                    <i><EmptyDeliverHoc /></i>
                    <span>No one is read yet!</span>
                </div>}
                {seenMembers.length > 0 && <div>
                    <ul className="chat-list-ul">
                        {
                            seenMembers.map(member => {
                                const { userId, seenTime } = member
                                return <Members
                                    time={seenTime}
                                    rosterData={rosterData}
                                    key={userId} jid={userId} />
                            })
                        }
                    </ul>
                </div>}

            </div>
        </Fragment>
    );
}

export default SeenMessageWrapper;
